if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      // Set up manual nav button events
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
        });
      }

      // ---- AUTOPLAY SETUP ----
      // We'll track the current autoplay direction
      this.autoPlayDirection = 'next';

      // Start an interval that triggers the slide change
      this.autoPlayInterval = setInterval(() => {
        this.changeSlide(this.autoPlayDirection);

        // If we're at the last slide, switch direction to 'prev'
        if (this.index === this.length - 1) {
          this.autoPlayDirection = 'prev';
        } 
        // If we're at the first slide, switch direction to 'next'
        else if (this.index === 0) {
          this.autoPlayDirection = 'next';
        }
      }, 3000); // change slide every 3 seconds
      // ---- END AUTOPLAY ----
    }

    changeSlide(direction) {
      this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if (direction === 'next') {
        this.index++;
      } else if (direction === 'prev') {
        this.index--;
      }

      if (this.index === this.length - 1) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled');
      } else if (this.index === 0) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled');
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    // (Optional) If you want to clean up the autoplay when the element is removed:
    disconnectedCallback() {
      clearInterval(this.autoPlayInterval);
    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}
